import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { postPassportById } from '../../services/studentApi';
import { AiOutlineLoading } from "react-icons/ai";
import useFormValidation from '../../hooks/useFormValidation';
import { passportFormValidationSchema } from '../../utils/formValidation';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { passport } from '../../utils/constant';
import { errorToast } from '../../utils/errorHandling';
import { actionTypes, useApp, useAppDispatch } from '../../features/AppContext';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';

const base_url = process.env.REACT_APP_BASE_URL

const CreatePassportInfo = () => {
    const { user_id, courseData, formcheck } = useApp();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const passportCopy = passport(t);
    const [formData, setFormData] = useState(null);
    const [passportRegion, setPassportRegion] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(passportFormValidationSchema(t));
    const navigate = useNavigate();
    const [passportExpiryDate, setPassportExpiryDate] = useState(null);
    const [passportExpired, setPassportExpired] = useState(null);

    useEffect(() => {
        setFormData({
            passport_region: "",
            ic_no: "",
            passport_no: "",
            passport_expired_date: "",
            passport_image: ""
        })
        const newDate = dayjs(courseData.start_datetime).add(6, 'month');
        setPassportExpiryDate(newDate);
    }, [])

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === "passport_region") {
            if (value === "Malaysia") {
                setFormData((prevState) => {
                    const { passport_no, passport_expired_date, passport_image, ...updatedFormData } = prevState;
                    return {
                        ...updatedFormData,
                        [id]: value,
                        ic_no: "",
                    };
                });
                validateField(id, value);
            } else {
                setFormData((prevState) => {
                    const { passport_no, ic_no, passport_expired_date, passport_image, ...updatedFormData } = prevState;
                    return {
                        ...updatedFormData,
                        [id]: value,
                        passport_no: passport_no || "",
                        passport_expired_date: passport_expired_date || "",
                        passport_image: passport_image || ""
                    };
                });
                validateField(id, value);
            }
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
        }
    };
    const handleDateChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            "passport_expired_date": e,
        }));
        validateField("passport_expired_date", e);
        if (e && e < passportExpiryDate) {
            setPassportExpired(t("FormValid.passportExpired"))
        } else {
            setPassportExpired(null);
        }
    };
    const [fileError, setFileError] = useState("");
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    const handleFileChange = (event) => {
        const { id } = event.target;
        const selectedFile = event.target.files[0];
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "image/jpg",
            "image/heic"
        ];
        if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
            setFileError(t("FormValid.FileExtensionAllow"));
            event.target.value = ""; // Clear the file input
            return;
        } else if (selectedFile && selectedFile.size > maxSize) {
            console.log(selectedFile.size);
            setFileError(t("FormValid.smallerFile"));
            event.target.value = ""; // Clear the file input
            return;
        } else {
            setFileError("");
            setFormData((prevState) => ({
                ...prevState,
                [id]: selectedFile,
            }));
            validateField(id, selectedFile);
        }
    };

    const handleCancel = () => {
        navigate(`${base_url}/passport-info`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const includeFields = Object.keys(formData);
        if (validateAllFields(formData, includeFields) && fileError === "" && passportExpired === null) {
            try {
                const payload = {
                    ...formData,
                    passport_expired_date: dayjs(formData.passport_expired_date).format("YYYY-MM-DD"),
                };
                const response = await postPassportById(user_id, payload);
                if (response) {
                    const formCheckData = {
                        ...formcheck,
                        is_passport_filled: '1'
                    };
                    dispatch({
                        type: actionTypes.UPDATE_FORMCHECK,
                        payload: formCheckData
                    });
                    toast.success(t("Passport.SubmitedSuccess"));
                    navigate(`${base_url}/passport-info`);
                }
            } catch (error) {
                errorToast(error, t("Passport.SubmitedFailed"), t);
            } finally {
                setIsSubmitting(false);
            }
        } else {
            toast.error(t("general.ValidateFailed"));
            setIsSubmitting(false);
        }
    };


    return (
        <>
            <div className='info-container'>
                <h3>{t("Passport.pTitle")}</h3>
                <p>{t("general.Des3rd")}</p>
                <div className='action-buttons'>
                    <Button buttonStyle='btn--primary' buttonSize='btn--small' onClick={handleCancel} type="button">{t("general.BTNcancel")}</Button>
                </div>
            </div>
            <div className='form-wrapper'>
                <form>
                    <div className="form-item">
                        <label for='passport_region'>{t("Passport.Region_pass")}
                            <span style={{ "color": "#ff0000" }}>*</span></label>
                        <select className="form-select" id='passport_region'
                            onChange={(e) => { setPassportRegion(e.target.value); handleInputChange(e) }}
                        >
                            <option value="">{t("Passport.Select_reg")}</option>
                            {
                                passportCopy.map((i, index) => (
                                    <option key={index} value={i.key}>{i.country}</option>
                                ))
                            }
                        </select>
                    </div>
                    {errors.passport_region && <span className="error">{errors.passport_region}</span>}
                    {
                        passportRegion === "Other" &&
                        <>
                            <div className="form-item">
                                <label for="other_passport_region" className="form-label">{t("Passport.Other_REG")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" className="form-control" id="other_passport_region" placeholder="" onChange={handleInputChange} required />
                            </div>
                            {errors.other_passport_region && <span className="error">{errors.other_passport_region}</span>}
                            <div className="form-info mt-2">
                                <p className='mb-0'>{t("Passport.fillOther")}</p>
                            </div>
                        </>
                    }
                    {
                        passportRegion === "Malaysia" &&
                        <>
                            <div className="form-item">
                                <label for="ic_no" className="form-label">{t("Passport.ICnum")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className="form-info mt-2">
                                    <p className='mb-0'>{t("Passport.fillIC")}</p>
                                </div>
                                <input type="text" className="form-control" id="ic_no" placeholder="790111-10-1234" onChange={handleInputChange} required />
                            </div>
                            {errors.ic_no && <span className="error">{errors.ic_no}</span>}
                        </>
                    }
                    {
                        passportRegion && passportRegion !== "Malaysia" &&
                        <>
                            <div className="form-item">
                                <label for="passport_no" className="form-label">{t("Passport.passNUM")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" className="form-control" id="passport_no" placeholder="" onChange={handleInputChange} required />
                            </div>
                            {errors.passport_no && <span className="error">{errors.passport_no}</span>}
                            <div className="form-item">
                                <label for="passport_expired_date" className="form-label">{t("Passport.passEXPIRED")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <DatePicker
                                    placeholder={t("general.date")}
                                    value={formData.passport_expired_date ? dayjs(formData.passport_expired_date) : null}
                                    onChange={handleDateChange}
                                />
                            </div>
                            {passportExpired && <span className="error">{passportExpired}</span>}
                            {errors.passport_expired_date && <span className="error">{errors.passport_expired_date}</span>}
                            <div className="form-item">
                                <label for="passport_image" className="form-label">
                                    {t("Passport.frontIMG")}
                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                <p className='mb-0'>{t("Passport.Sample")}</p>
                                <img src={`${base_url}/images/passport.png`} alt="" style={{ "width": "200px" }} />
                                <input
                                    type="file"
                                    className="form-control mt-2"
                                    onChange={handleFileChange}
                                    id="passport_image"
                                />
                            </div>
                            <div className="form-info mt-2">
                                <p className='mb-0'>{t("general.smallerFile")}</p>
                            </div>
                            {fileError && <span className="error">{fileError}</span>}
                            {errors.passport_image && <span className="error">{errors.passport_image}</span>}
                        </>
                    }
                    <div className='submit-button d-flex justify-content-center mt-4 gap-3'>
                        <Button buttonStyle='btn--primary' disabled={isSubmitting} onClick={handleSubmit} type="button">
                            {isSubmitting ? <AiOutlineLoading className="spin" /> : t("Passport.SAVEbtn")}
                        </Button>
                    </div>

                </form>
            </div>

        </>
    )
}

export default CreatePassportInfo